class EventEmitter {
  events = new Map();
  // 监听事件
  on (name, fn) {
    if (!this.events.has(name)) {
      this.events.set(name, new Set());
    }
    this.events.get(name).add(fn);
  }
  // 触发事件
  trigger (name, ...args) {
    if (!this.events.has(name)) return false;
    this.events.get(name).forEach(fn => fn.apply(this, args));
  }
  // 删除事件 remove/fire
  remove (name, fn) {
    if (!fn) return this.events.delete(name);
    const fns = this.events.get(name);
    if (fns && fns.has(fn)) {
      fns.delete(fn);
    }
  }
  // 单次监听事件
  once (name, fn) {
    const onceFn = (...args) => {
      fn.apply(this, args);
      this.remove(name, onceFn);
    }
    this.on(name, onceFn);
  }
}

window.vograceEventEmitter = new EventEmitter();
